/**
 * The ArrayIterator is an iterator implementation for arrays
 * @constructor
 * @param {Array} array
 * @returns {undefined}
 */

import Iterator from "../Iterator";

export default class ArrayIterator extends Iterator {
    constructor(array) {
        super();

        this.array = typeof array !== 'undefined' ? array : [];
        this.currentIndex = 0;
    };

    start() {
        this.currentIndex = 0;
    };

    /**
     * Retrieves the current item and moves the iterator to the next item in the sequence.
     * @returns {*}
     */
    next() {
        if (this.hasNext()) {
            this.currentIndex++;
            return this.array[this.currentIndex - 1];
        }
        return null;
    };

    /**
     * Checks if the next item exists.
     * @returns {Boolean}
     */
    hasNext() {
        return this.currentIndex < this.array.length;
    };

    /**
     * Grants access to the current item being referenced by the iterator.
     * @returns {unresolved}
     */
    getData() {
        return this.array[this.currentIndex];
    };

    setData(value) {
        this.array[this.currentIndex] = value;
    };
}